import "./TrainingInHarmony.module.css";
import Header from "@/reusable_sections/Header";
import LocalFlavor from "./sections/LocalFlavor";
import RetailSolutions from "./sections/RetailSolutions";
import SchreibenSieUns from "./sections/SchreibenSieUns";
import Footer from "@/reusable_sections/Footer";
export default function TrainingInHarmonyPage() {
  return <div>
      <Header />
      <LocalFlavor />
      <RetailSolutions />
      <SchreibenSieUns />
      <Footer />
    </div>;
}